import { useEffect, useState } from 'react';
import GlobalNavbarEN from '../../../components/feature/GlobalNavbarEN';
import HeroSection from './components/HeroSection';
import WhySection from './components/WhySection';
import ServicesSection from './components/ServicesSection';
import FeaturedCampaigns from './components/FeaturedCampaigns';
import InvestmentBenefits from './components/InvestmentBenefits';
import LatestInsights from './components/LatestInsights';
import CTASection from './components/CTASection';
import FooterEN from '../../home/components/FooterEN';

export default function HomePageEN() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-black font-inter">
      <GlobalNavbarEN />
      <HeroSection />
      <WhySection />
      <FeaturedCampaigns />
      <InvestmentBenefits />
      <ServicesSection />
      <LatestInsights />
      <CTASection />
      <FooterEN />
    </div>
  );
}
